import React from 'react';
import { Link, useLocation } from 'react-router-dom';

// Import your logo
import logo from '../assets/images/logos/company-logo.png';

function Header() {
  const location = useLocation();
  
  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  return (
    <header className="glass-header">
      <nav className="container">
        <Link to="/" className="logo" style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          {/* Logo Image */}
          <img 
            src={logo} 
            alt="Company Logo" 
            style={{
              height: '70px',
              width: 'auto',
              objectFit: 'contain'
            }}
          />
          <span className="logo-text" style={{ fontFamily: "'Space Grotesk', sans-serif" }}></span>
        </Link>
        <ul className="nav-links" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
          <li><Link to="/" className={isActive('/')}>Home</Link></li>
          <li><Link to="/about" className={isActive('/about')}>About</Link></li>
          <li><Link to="/features" className={isActive('/features')}>Features</Link></li>
          <li><Link to="/benefits" className={isActive('/benefits')}>Solutions</Link></li>
          <li><Link to="/contact" className={isActive('/contact')}>Contact</Link></li>
        </ul>
        <Link to="/contact" className="cta-button-small" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>Get Started</Link>
      </nav>
    </header>
  );
}

export default Header;
